export class PollingTimeoutException extends Error {
    constructor() {
        super();
        this.name = 'PollingTimeoutException';
    }
}
export const wait = (ms = 1000) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
/**
 * The poll function is a utility designed to repeatedly execute an asynchronous operation (fn)
 * at a specified interval (pollInterval) until a condition (fnCondition) is met or a maximum
 * number of attempts (maxAttempts) is reached. It also includes error handling for network failures
 * and throws a custom exception (PollingTimeoutException) if the polling exceeds the allowed attempts.
 */
export const poll = async (fn, fnCondition, pollInterval = 2000, maxAttempts = 15) => {
    let failedNetworkAttempts = 0;
    let attempts = 1;
    let result = await fn().catch(() => {
        failedNetworkAttempts += 1;
    });
    while (fnCondition(result)) {
        // eslint-disable-next-line no-await-in-loop
        await wait(pollInterval);
        if (attempts > maxAttempts) {
            throw new PollingTimeoutException();
        }
        try {
            // eslint-disable-next-line no-await-in-loop
            result = await fn();
            failedNetworkAttempts = 0;
        }
        catch (ex) {
            failedNetworkAttempts += 1;
            if (failedNetworkAttempts > 1) {
                throw ex;
            }
        }
        attempts += 1;
    }
    return result;
};
